// ReelModal.tsx
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { getYoutubeEmbedUrl } from "../../shared/commonUtils";

interface Props {
  open: boolean;
  onClose: () => void;
  youtubeId: string; // "OCFJNvhj4hI"
}

export default function ReelModal({ open, onClose, youtubeId }: Props) {
  // Close on ESC
  useEffect(() => {
    const handler = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  if (!open) return null;

  return createPortal(
    <div className="reel‑backdrop" onClick={onClose}>
      <div
        className="reel‑container"
        onClick={(e) => e.stopPropagation()} /* prevent outside click */
      >
        <button aria-label="Close" className="reel‑close" onClick={onClose}>
          &times;
        </button>

        <iframe
          className="reel‑iframe"
          title="Short‑form video"
          src={getYoutubeEmbedUrl(youtubeId)}
          //   src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&playsinline=1&modestbranding=1`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>,
    document.body
  );
}
